import React from "react";
// import Login from "../views/auth/Login";
import Landing from "../pages/Login";
import PublicMiddleware from "./middleware/PublicMiddleware";

import BaseTemplateLanding from "../layout/BaseTemplateLanding";
import BaseTemplateLogin from "../layout/BaseTemplateLogin";

const PUBLIC_ROUTES = {
    // LOGIN: {
    //     path: "/intranet/login",
    //     title: "Ingresar",
    //     component: Login,
    //     exact: true,
    //     layout: props => <BaseTemplateLogin {...props} />,
    //     middleware: props => <PublicMiddleware {...props} />
    // },
    HOME: {
        path: "/intranet/login",
        title: "Ingresar",
        component: Landing,
        exact: true,
        layout: props => <BaseTemplateLogin {...props} />,
        middleware: props => <PublicMiddleware {...props} />
    },
};

export default PUBLIC_ROUTES;
